<template>
    <div class="layer">
        <div class="wrap">
            <HeaderLayout></HeaderLayout>
            <div class="content">
                <button type="button" class="in_back_btn" @click="$router.back()">
                    <img src="@/assets/user/line_back_ico_l.png" alt="">
                    <span>BACK</span>
                </button>
                <p class="page_title">설문조사</p>
                <SurveyList :data="survey.data" :surveyIdx="state.idx" @submit="surveyEntry"></SurveyList>
            </div>
        </div>
    </div>
    <GnbLayout></GnbLayout>
    <ModalComponent :show="state.isModalOpen" :content="modal.content" :yes="modal.confirm" :no="modal.cancel"
        @close="modalClose"></ModalComponent>
</template>
<script lang="ts" config>
import {
    DataGrid,
    HeaderLayout,
    GnbLayout,
    reactive,
    onMounted,
    apiService,
    useRoute,
    router,
    ModalComponent,
} from "@/BaseComponent";
import SurveyList from "@/components/surveyList.vue";

export default {
    components: {
        DataGrid,
        HeaderLayout,
        GnbLayout,
        SurveyList,
        ModalComponent,
    },
    setup() {
        const route = useRoute();
        const state = reactive({
            idx: route.params.idx as any,
            isModalOpen: false,
        });
        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
            actionCode: 0 as number
        });
        const survey = reactive({
            data: [] as any
        });
        onMounted(() => {
            getDetail();
        });

        const getDetail = async () => {
            const res = await apiService.survey.getDetail(state.idx);
            if (res.returnCode === 0) {
                survey.data = res.list;
            } else {
                state.isModalOpen = true;
                modal.content = res.description;
                modal.confirm = "확인";
                modal.cancel = "";
            }
        };

        const backList = () => {
            router.back();
        };

        const surveyEntry = async (result: any) => {
            const res = await apiService.survey.answer(result);
            if (res.returnCode === 0) {
                state.isModalOpen = true;
                modal.content = "설문참여가 완료되었습니다.<br>수고하셨습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
            } else {
                state.isModalOpen = true;
                modal.content = res.description;
                modal.confirm = "";
                modal.cancel = "확인";
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result === true) {
                router.replace('/survey/list');
            }
        };

        return {
            state,
            modal,
            survey,
            modalClose,
            backList,
            surveyEntry,
        };
    }
};
</script>